import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import { Declaration } from 'store/declarations/declaration';
import { getDescriptionOfGoods } from 'views/declarations/utils/declaration-utils';

type Props = {
    dataTestId: string;
    declaration?: Declaration;
};

const Items = ({ dataTestId, declaration }: Props) => {
    if (!declaration) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    const { numberOfItems } = getDescriptionOfGoods(declaration);
    return <span data-testid={dataTestId}>{numberOfItems}</span>;
};

export default Items;
